import { useEffect } from 'react';
import PropTypes from 'prop-types';

import loadStyleSheet from '@gef-ui/utils/loadStyleSheet';

const loadCssForLoader = async () => {
	if (__DEV__) {
		require('app/configurator/components/style.scss');
	} else {
		await loadStyleSheet(`/loader_${process.env.APP_GIT_COMMITHASH}.css`);
	}
};

const InitDelegations = (props) => {
	useEffect(() => {
		async function loadStyles() {
			await loadCssForLoader();
		}
		loadStyles();
	}, []);

	return props.children;
};

InitDelegations.propTypes = {
	children: PropTypes.any,
};

export default InitDelegations;
